export * from '@primeuix/themes/nora/iftalabel';
export { default } from '@primeuix/themes/nora/iftalabel';
